import { render, staticRenderFns } from "./TabBloodPressure.vue?vue&type=template&id=f7822ae6&scoped=true&"
import script from "./TabBloodPressure.vue?vue&type=script&lang=js&"
export * from "./TabBloodPressure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7822ae6",
  null
  
)

export default component.exports